import {
    type MoneyMap,
    MoneyMapStatus,
    type MoneyMapUpdateStatusDto,
} from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

interface UpdateMoneyMapStatusParams {
    id: string;
}

export const useUpdateMoneyMapStatus = requestBuilder.mutation<
    MoneyMap,
    MoneyMapUpdateStatusDto,
    UpdateMoneyMapStatusParams
>({
    endpoint: ({ id }) => `/api/admin/money-map/${id}/status`,
    method: 'PATCH',
});

export const usePublishMoneyMap = () => {
    const { mutateAsync } = useUpdateMoneyMapStatus();

    const setMoneyMapToPreviewAsync = async (id: string) => {
        return await mutateAsync({
            urlParams: {
                id,
            },
            body: {
                status: MoneyMapStatus.PREVIEW,
            },
        });
    };

    return {
        setMoneyMapToPreviewAsync,
    };
};

export const useFinalizeMoneyMap = () => {
    const { mutateAsync } = useUpdateMoneyMapStatus();

    const setMoneyMapToActiveAsync = async (id: string) => {
        return await mutateAsync({
            urlParams: {
                id,
            },
            body: {
                status: MoneyMapStatus.ACTIVE,
            },
        });
    };

    return {
        setMoneyMapToActiveAsync,
    };
};

export const useArchiveMoneyMap = () => {
    const { mutateAsync } = useUpdateMoneyMapStatus();

    const setMoneyMapToInactiveAsync = async (id: string) => {
        return await mutateAsync({
            urlParams: {
                id,
            },
            body: {
                status: MoneyMapStatus.INACTIVE,
            },
        });
    };

    return {
        setMoneyMapToInactiveAsync,
    };
};

export const useDraftMoneyMap = () => {
    const { mutateAsync } = useUpdateMoneyMapStatus();

    const setMoneyMapToDraftAsync = async (id: string) => {
        return await mutateAsync({
            urlParams: {
                id,
            },
            body: {
                status: MoneyMapStatus.DRAFT,
            },
        });
    };

    return {
        setMoneyMapToDraftAsync,
    };
};
